<div [style.minHeight.px]="height" class="w-100 d-flex justify-content-center align-items-center">
  @if (isLoading) {
    <div>{{'COMMON.LOADING' | translate}}</div>
  } @else {
    <div>{{'COMMON.NO_DATA' | translate}}</div>
  }
</div>
